<template>
  <!-- 需求审批流程-待我审批 -->
  <div>
    <el-card class="refund_home" shadow="hover">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-button type="primary" plain circle icon="el-icon-pie-chart" @click="gotoPage('/RAP/initiateRAP')"></el-button>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-button type="warning" plain circle icon="el-icon-pie-chart" @click="gotoPage('/RAP/myApproveListYetRAP')"></el-button>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-button type="danger" plain circle icon="el-icon-pie-chart" @click="gotoPage('/RAP/myRAPList')"></el-button>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-button type="success" plain circle icon="el-icon-pie-chart" @click="gotoPage('/RAP/ccRAPList')"></el-button>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <div class="sub">发起审批</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <div class="sub">我已审批</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <div class="sub">我发起的</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <div class="sub">抄送我的</div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card shadow="hover">
    <el-row>
      <!-- 面包屑导航区域 -->
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/RAP/myApproveListRAP' }">需求审批流程</el-breadcrumb-item>
          <el-breadcrumb-item>待我审批</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-row>
      <el-col style="text-align:left;" :span="2">
        <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
      </el-col>
    </el-row>
    <!-- 表格区域 -->
    <el-table :data="tableData" border stripe v-loading="loading" style="width: 100%">
      <el-table-column type="index"></el-table-column>
      <el-table-column label="标题" width="250">
        <template slot-scope="scope">
          <el-link @click="DialogBox(scope.row)" type="primary">{{scope.row.Title}}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="StepName" label="当前步骤" width="180"></el-table-column>
      <el-table-column prop="ReceiveName" label="处理人" width="110"></el-table-column>
      <el-table-column prop="SenderTime" label="发起时间" width="250"></el-table-column>
      <el-table-column label="操作" >
        <template slot-scope="scope">
          <el-tooltip content="通过" placement="top" :enterable="false">
            <el-button type="success" size="mini" icon="el-icon-circle-check" circle @click="pass(scope.row)"></el-button>
          </el-tooltip>
          <!-- <el-popover
            placement="top-start"
            title="标题"
            width="200"
            trigger="hover"
            content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
            <el-button type="success" size="mini" icon="el-icon-circle-check" circle @click="pass(scope.row)"></el-button>
          </el-popover> -->
          <!-- <el-tooltip content="完成" placement="top" :enterable="false">
            <el-button type="success" size="mini" icon="el-icon-check" circle @click="finsh(scope.row)"></el-button>
          </el-tooltip> -->
          <el-tooltip content="拒绝" placement="top" :enterable="false">
            <el-button type="danger" icon="el-icon-close" circle  size="mini" @click="reject(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip content="通过并抄送" placement="top" :enterable="false">
            <el-button type="info" icon="el-icon-s-promotion" size="mini" circle @click="ccDialogBox(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip content="转交" placement="top" :enterable="false">
            <el-button type="warning" icon="el-icon-refresh" size="mini" circle @click="transmitDialogBox(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip content="查看" placement="top" :enterable="false">
            <el-button type="primary" icon="el-icon-view" size="mini" circle @click="DialogBox(scope.row)"></el-button>
          </el-tooltip>
          <!-- <el-tooltip content="驳回" placement="top" :enterable="false">
            <el-button type="danger" icon="el-icon-refresh-left" size="mini" circle @click="turnDown(scope.row)"></el-button>
          </el-tooltip> -->
          <el-dialog title="审批详情" :visible.sync="DialogVisible" width="70%" center >
            <div class="drawer_box">
              <el-steps :active="level" align-center >
                <el-step v-for="(item, index) in TimeLines" :key="index" :title="item.Name" :status="item.Result">
                  <template slot="description">
                    <div>{{item.CompletedTime}}</div>
                    <div>{{item.Handler}}</div>
                    <div>{{item.ResultMessage}}</div>
                  </template>
                </el-step>
              </el-steps>
              <div class="downloadBtn" >
                <el-button v-if="rowInfo.FangAnUrl == null ? false : true" size="mini" type="primary" @click="download_doc(rowInfo.FangAnUrl)" >下载方案<i class="el-icon-download "></i></el-button>
                <el-button v-if="rowInfo.Attachment == '' ? false : true" size="mini" type="primary" @click="download_doc(rowInfo.Attachment)" >下载附件<i class="el-icon-download "></i></el-button>
              </div>
              <div class="info_table">
                <el-row>
                  <el-col class="tableTitle" :span="6">编号</el-col>
                  <el-col class="tableTitle" :span="6">主题</el-col>
                  <el-col class="tableTitle" :span="6">需求类型</el-col>
                  <el-col class="tableTitle" :span="6">项目名称</el-col>
                </el-row>
                <el-row class="tableRow">
                  <el-col class="tableTd" :span="6">{{rowInfo.NeedNo}}</el-col>
                  <el-col class="tableTd" :span="6">{{ rowInfo.Theme }}</el-col>
                  <el-col class="tableTd" :span="6">{{ rowInfo.TypeName + ' / ' + rowInfo.CateName }}</el-col>
                  <el-col class="tableTd" :span="6">{{ rowInfo.ProjectName }}</el-col>
                </el-row>
                <el-row class="tableRow">
                  <el-col class="tableTitle" :span="6">需求部门名称</el-col>
                  <el-col class="tableTitle" :span="6">是否公司级需求</el-col>
                  <el-col class="tableTitle" :span="6">是否限制交付时间</el-col>
                  <el-col class="tableTitle" :span="6">预期交付日期</el-col>
                </el-row>
                <el-row class="tableRow">
                  <el-col class="tableTd" :span="6">{{rowInfo.DepartmentName}}</el-col>
                  <el-col class="tableTd" :span="6">{{ rowInfo.IsCompany == 1 ? '是' : '否' }}</el-col>
                  <el-col class="tableTd" :span="6">{{ rowInfo.IsLimitTime == 1 ? '是' : '否'}}</el-col>
                  <el-col class="tableTd" :span="6">{{ rowInfo.GiveDate == null ? '未设置' : rowInfo.GiveDate}}</el-col>
                </el-row>
                <div class="tableRowBox">
                  <div class="table_left">
                    <span>主要问题</span>
                  </div>
                  <div class="table_right">
                    {{ rowInfo.MainQuestion }}
                  </div>
                </div>
                <div class="tableRowBox">
                  <div class="table_left">
                    <span>使用范围</span>
                  </div>
                  <div class="table_right">
                    {{ rowInfo.UseRange }}
                  </div>
                </div>
                <div class="tableRowBox">
                  <div class="table_left">
                    <span>影响范围</span>
                  </div>
                  <div class="table_right">
                    {{ rowInfo.EffectRange }}
                  </div>
                </div>
                <div class="tableRowBox">
                  <div class="table_left" style="border-bottom:0px solid #000;">
                    <span>预期价值</span>
                  </div>
                  <div class="table_right">
                    {{ rowInfo.ExpectedValue }}
                  </div>
                </div>
              </div>
            </div>
          </el-dialog>
          <el-dialog title="通过审批并选择业务咨询师" :visible.sync="passDialogVisible" width="40%" center @close="passDialogClose">
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="ccDialogText">通过备注</div>
              </el-col>
              <el-col :span="10">
                <el-input v-model="passRemark" placeholder="请输入备注" size="small" style="width:280px;"></el-input>
              </el-col>
            </el-row>
            <el-row style="margin-top:10px;" :gutter="20">
              <el-col :span="8">
                <div class="ccDialogText">请选择咨询师</div>
              </el-col>
              <el-col :span="10">
                <el-cascader :props="ccProps" :show-all-levels="false" size="small" v-model="ccId"></el-cascader>
              </el-col>
            </el-row>
            <el-row style="text-align:center;margin-top:20px;" :gutter="20">
              <el-col :span="24">
                <div class="ccDialogBtn"><el-button type="primary" size="mini" @click="passBtn(scope.row)">确认</el-button></div>
              </el-col>
            </el-row>
          </el-dialog>
           <el-dialog title="通过并上传方案" :visible.sync="passFangAnDialogVisible" width="40%" center @close="passFangAnDialogClose">
             <el-row :gutter="20">
              <el-col :span="8">
                <div class="ccDialogText">通过备注</div>
              </el-col>
              <el-col :span="10">
                <el-input v-model="passRemark" placeholder="请输入备注" size="small" style="width:280px;"></el-input>
              </el-col>
            </el-row>
            <el-row style="margin-top:10px;" :gutter="20">
              <el-col :span="8">
                <div class="ccDialogText">请上传方案审核附件</div>
              </el-col>
              <el-col :span="10">
                <!-- 退款确认书 -->
                <!-- <el-form-item label="请上传附件" label-width="120px"> -->
                  <el-upload
                    style="float:left;"
                    class="upload-demo"
                    action="http://flow.text.ruizhiqi.com/api/public/needflow/UploadFile"
                    :on-success="handleSuccessRAPConfirmation"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    :limit="1"
                    :on-exceed="handleExceed"
                    :file-list="fileList"
                    >
                    <!-- slot="trigger" type="primary"-->
                    <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
                    <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="download_doc()" >下载模板</el-button> -->
                    <!-- <div slot="tip" class="el-upload__tip">
                      需加盖红色公章
                    </div> -->
                  </el-upload>
                <!-- </el-form-item> -->
              </el-col>
            </el-row>
            <el-row style="text-align:center;margin-top:20px;" :gutter="20">
              <el-col :span="24">
                <div class="ccDialogBtn"><el-button type="primary" size="mini" @click="passFangAnBtn(scope.row)">确认</el-button></div>
              </el-col>
            </el-row>
          </el-dialog>
          <el-dialog title="通过审批并选择抄送对象" :visible.sync="ccDialogVisible" width="40%" center @close="ccDialogClose">
            <el-row :gutter="20">
              <el-col :span="6">
                <div class="ccDialogText">抄送对象</div>
              </el-col>
              <el-col :span="8">
                <el-cascader :props="ccProps" :show-all-levels="false" size="small" v-model="ccId"></el-cascader>
              </el-col>
            </el-row>
            <el-row style="text-align:center;margin-top:20px;" :gutter="20">
              <el-col :span="24">
                <div class="ccDialogBtn"><el-button type="primary" size="mini" @click="ccBtn(scope.row)">确认</el-button></div>
              </el-col>
            </el-row>
          </el-dialog>
          <el-dialog title="转交审批" :visible.sync="transmitDialogVisible" width="50%" center @close="transmitDialogClose">
            <el-row :gutter="20">
              <el-col :span="3">
                <div class="ccDialogText">转交对象</div>
              </el-col>
              <el-col :span="7">
                <el-cascader :props="ccProps" :show-all-levels="false" size="small" v-model="ccId" ref="TransmitCascader"></el-cascader>
              </el-col>
              <el-col :span="2">
                <div class="ccDialogText">备注</div>
              </el-col>
              <el-col :span="8">
                <el-input v-model="reason" placeholder="请输入备注" size="small" style="width:220px;"></el-input>
              </el-col>
            </el-row>
            <el-row style="text-align:center;margin-top:20px;" :gutter="20">
              <el-col :span="24">
                <div class="ccDialogBtn"><el-button type="primary" size="mini" @click="transmitBtn">确认</el-button></div>
              </el-col>
            </el-row>
          </el-dialog>
          <el-dialog title="拒绝审批" :visible.sync="refuseDialogVisible" width="50%" center @close="refuseDialogClose">
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="ccDialogText">拒绝原因</div>
              </el-col>
              <el-col :span="10">
                <el-input v-model="refuseRemark" placeholder="请输入备注" size="small" style="width:280px;"></el-input>
              </el-col>
            </el-row>
            <el-row style="text-align:center;margin-top:20px;"  :gutter="20">
              <el-col :span="24">
                <div class="ccDialogBtn"><el-button type="primary" size="mini" @click="refuseReject">确认</el-button></div>
              </el-col>
            </el-row>
          </el-dialog>
          <el-dialog title="通过审批" :visible.sync="passDV" width="50%" center @close="passDialogClose">
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="ccDialogText">通过备注</div>
              </el-col>
              <el-col :span="10">
                <el-input v-model="passRemark" placeholder="请输入备注" size="small" style="width:280px;"></el-input>
              </el-col>
            </el-row>
            <el-row style="text-align:center;margin-top:20px;"  :gutter="20">
              <el-col :span="24">
                <div class="ccDialogBtn"><el-button type="primary" size="mini" @click="passReamrk(passRow,'')">确认</el-button></div>
              </el-col>
            </el-row>
          </el-dialog>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页区域 -->
    <el-pagination
      style="text-align:left;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50 ,100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    </el-card>
  </div>
</template>
<script>
let id = 0;
import { GetFrameByParentId,GetUserByParentId,GetSingeleUser } from "../../until/ZeusApiSDK/Logic/StructureLogic";
import { GetNeedFlowMeList,GetRAPWaitTasks,GetStepTimeLine,GetNeedDtail,GetRAPFlowSendNextSteps,RAPExcuteflow,RAPRefuse,RAPFinshflow,RAPHandOverOper,GetRAPBtn,GetNeedFlowList,UpdateData } from "../../until/ZeusApiSDK/Logic/RAPLogic.js";
import { cryptoDecode } from "../../until/encrypt.js"

export default {
  data() {
    return {
      userInfo: {},
      keywords: "",
      refuseRemark:'',//拒绝原因
      passRemark : '',//通过原因
      refuseRow:{},//拒绝行数据
      DialogVisible: false,
      ccDialogVisible : false,
      transmitDialogVisible : false,
      refuseDialogVisible:false,
      passDialogVisible:false,
      passFangAnDialogVisible:false,
      passDV:false,
      passRow:{},//通过行数据
      tableData: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      searchInstance: [],
      TimeLines: [],
      level: 0,
      rowInfo: {},
      Material: {},
      ccProps: {},
      ccId:'',
      zixunUserId:'',//咨询师id
      itemInfo:{},
      taskId : '',
      reason : '',
      transmitName : '',
      loading : true,
      step:[],//流程步骤
      FangAnUrl:'',
      fileList: [],
    };
  },
  methods: {
    //跳转页面
    gotoPage: function(url) {
      if (url.indexOf("http://") > -1) {
        var sp = url.indexOf("?") > -1 ? "&" : "?";
        window.open(url + sp + "token=" + sessionStorage.getItem("token"));
      } else {
        // url = "/" + url;
        this.$router.push(url);
      }
    },
    //刷新
    Refresh:function(){
      this.GetRAPWaitTasks();
    },
    //下载模板
    download_doc(file_path) {
      window.open(file_path);
    },
    // //动态获取按钮 FlowID  StepID  
    // async GetRAPBtn(){
    //   var res = await GetRAPBtn('0a41fb67-42d2-4d71-bbf9-acf79a334a1a','d8eda1d6-faa2-4f39-a4fb-ad1eee618b0b');
    // },
    //获取待办事项(待审批)
    GetRAPWaitTasks: async function() {
      this.loading = true;
      await GetNeedFlowList().then(async res => {
        this.searchInstance = res.Data;
      });
      await GetRAPWaitTasks(this.userInfo.userid,this.pageIndex,this.pageSize,this.searchInstance).then(res => {
        this.total = res.TotalCount;
        this.tableData = res.DataList;
        this.loading = false;
      });
    },
    //监听每页展示多少条数据改变事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetRAPWaitTasks();
    },
    //监听当前页码改变事件
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetRAPWaitTasks();
    },
    //拒绝审批
    async reject(row) {
      this.refuseRow=row;
      this.refuseDialogVisible=true;
    },
    //通过审批dialog
    // async passDVFunction(row) {
    //   this.passRow = row;
    //   this.passDV = true;
    // },
    /**
     * 上传所需退款资料 start
     */
    // 退款确认书
    handleSuccessRAPConfirmation(response) {
      if( response.Result == 200 ){
        this.$message({
          message: "上传附件成功",
          type: "success"
        });
        this.FangAnUrl = response.Data;
      }else{
        this.$message.error("上传附件失败");
      }
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleRemove(file, fileList) {
    },
    handlePreview(file) {
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    //点击确定并拒绝
    async refuseReject(){
      await GetRAPFlowSendNextSteps(this.userInfo.userid,this.refuseRow.StepID,this.refuseRow.InstanceID).then(res => {
        var step = [];
        res.forEach(element => {
          var obj = {
            id: element.Step.ID,
            member: element.DefaultMemberID
          };
          step.push(obj);
        });
        var paras = {
          flowid: "0a41fb67-42d2-4d71-bbf9-acf79a334a1a",
          senderid: this.userInfo.userid,
          instanceid: this.refuseRow.InstanceID,
          data: [],
          step: step,
          type: "refuse",//坑
          isfirststep: false,
          taskid: this.refuseRow.ID,
          stepid: this.refuseRow.StepID,
          comment: this.refuseRemark,
          groupid: this.refuseRow.GroupID,
          title: this.refuseRow.Title,
          ccid: "",
          ccname: "",
          sendername: this.userInfo.TrueName
        };
        RAPRefuse(paras).then(res => {
          if (res.msg == "已完成") {
            this.refuseDialogVisible= false;
            this.$message({
              message: "拒绝成功",
              type: "success"
            });
            this.GetRAPWaitTasks();
          } else {
            this.$message.error("拒绝失败,请重试");
          }
        });
      });
    },
    //通过审批
    async pass(row,ccId) {
      var ccid = '';
      if(ccId == undefined){
        ccid = '';
      }else{
        ccid = ccId;
      }
      await GetRAPFlowSendNextSteps(this.userInfo.userid,row.StepID,row.InstanceID).then(res => {
        var step = [];
        res.forEach(element => {
          var obj = {
            id: element.Step.ID,
            member: element.DefaultMemberID
          };
          step.push(obj);
        });
        this.step=step;
        //保存行数据
        this.passRow=row;
        if(step==undefined||step==null||step.length==0){
          //如果没有下一步则直接完成
          this.finsh(this.passRow,ccid);
        }
        else{
          if(step[0].id=="f8de62f7-470f-435a-a8a1-5d34be70ba76"){
            //如果下一步是需求初审
            //需求内审 选择人员
            this.passDialogVisible=true;
            this.ccProps = {
              lazy: true,
              lazyLoad: (node, resolve) => {
                GetFrameByParentId(node.value).then((res) => {
                  if (res.length > 0) {
                    var nodes = [];
                    res.forEach((element) => {
                      var node = {
                        value: element.Id,
                        label: element.ClassName,
                        leaf: false,
                      };
                      nodes.push(node);
                    });
                    resolve(nodes);
                  } else {
                    GetUserByParentId(node.value).then((users) => {
                      var nodes = [];
                      if (users.DataList.length > 0) {
                        users.DataList.forEach((element) => {
                          var node = {
                            value: element.Id,
                            label: element.TrueName,
                            leaf: true,
                          };
                          nodes.push(node);
                        });
                      }
                      resolve(nodes);
                    });
                  }
                });
              },
            }
          }
          else if(step[0].id=="d023d5b8-b53f-4686-9a62-330f5517aa35"){
            //如果下一步是方案审核  上传文件
            this.passFangAnDialogVisible=true;
            this.ccProps = {
              lazy: true,
              lazyLoad: (node, resolve) => {
                GetFrameByParentId(node.value).then((res) => {
                  if (res.length > 0) {
                    var nodes = [];
                    res.forEach((element) => {
                      var node = {
                        value: element.Id,
                        label: element.ClassName,
                        leaf: false,
                      };
                      nodes.push(node);
                    });
                    resolve(nodes);
                  } else {
                    GetUserByParentId(node.value).then((users) => {
                      var nodes = [];
                      if (users.DataList.length > 0) {
                        users.DataList.forEach((element) => {
                          var node = {
                            value: element.Id,
                            label: element.TrueName,
                            leaf: true,
                          };
                          nodes.push(node);
                        });
                      }
                      resolve(nodes);
                    });
                  }
                });
              },
            }
          }
          else{
            this.passDV = true;
            //直接保存
            // this.passRAPFlow(step,ccid,[]);
          }
        }
        
      });
    },
    //通过添加备注
    passReamrk:function(row){
      // console.log('this.passRemark',this.passRemark);
      // console.log("rowrowrowrow",row);
      // console.log("this.step",this.step);
      // console.log("this.ccId",this.ccId);
      this.passRow.Comment=this.passRemark;
      this.passRAPFlow(this.step,this.ccId,[]);
    },
    //需求初审通过
    async passBtn(row){
      this.passRow.Comment=this.passRemark;
      this.ccId = this.ccId[this.ccId.length-1];
      await GetSingeleUser(this.ccId).then(res=>{
        var data=[{"field":"InitiatorID","value":this.ccId},{"field":"Initiator","value": res.TrueName}];
        this.passRAPFlow(this.step,this.ccId,data);
      })
    },
    //上传方案
    async passFangAnBtn(row){
      this.passRow.Comment=this.passRemark;
      //获取详情
      await GetNeedDtail(this.passRow.InstanceID).then(res=>{
        console.log("res",res);
        res.Data.FangAnUrl=this.FangAnUrl;
        //更新数据
        UpdateData(res.Data).then(data=>{
          console.log("data",data)
          if(data.Result=="200"){
            //通过
            this.passRAPFlow(this.step,this.ccId,[]);
      
          }else{
            this.$message.error("审核失败，请联系管理员");
          }
        })
      });
    },
    //通过数据
    async passRAPFlow(step,ccId,data){
      var paras = {
          flowid: "0a41fb67-42d2-4d71-bbf9-acf79a334a1a",
          //当前用户id
          senderid: this.userInfo.userid,
          instanceid: this.passRow.InstanceID,
          data: data,
          step: step,
          type: "submit",
          isfirststep: false,
          taskid: this.passRow.ID,
          stepid: this.passRow.StepID,
          comment: this.passRow.Comment,
          groupid: this.passRow.GroupID,
          title: this.passRow.Title,
          ccid: ccId,
          ccname: "",
          sendername: this.userInfo.TrueName
        };
        RAPExcuteflow(paras).then(res => {
          if (res.msg == "操作成功") {
            this.DialogVisible=false;
            this.ccDialogVisible=false;
            this.transmitDialogVisible=false;
            this.refuseDialogVisible=false;
            this.passDV=false;
            this.passDialogVisible=false;
            this.passFangAnDialogVisible=false;
            this.passRemark="";
            this.$message({message: "操作成功~",type: "success"});
            //this.reload();
            this.GetRAPWaitTasks();
          } else {
            this.$message.error("审批失败,请重试");
          }
        });
    },
    //驳回审批 turnDown
    turnDown(row){
    },
    //完成审批
    async finsh(row,ccId) {
      if(ccId == undefined){
        var ccid = '';
      }else{
        var ccid = ccId;
      }
      await GetRAPFlowSendNextSteps(this.userInfo.userid,row.StepID,row.InstanceID).then(res => {
        var step = [];
        res.forEach(element => {
          var obj = {
            id: element.Step.ID,
            member: element.DefaultMemberID
          };
          step.push(obj);
        });
        var paras = {
          flowid: "0a41fb67-42d2-4d71-bbf9-acf79a334a1a",
          //当前用户id
          senderid: this.userInfo.userid,
          instanceid: row.InstanceID,
          data: [],
          step: step,
          type: "completed",
          isfirststep: false,
          taskid: row.ID,
          stepid: row.StepID,
          comment: row.Comment,
          groupid: row.GroupID,
          title: row.Title,
          ccid: ccid,
          ccname: "",
          sendername: this.userInfo.TrueName
        };
        RAPFinshflow(paras).then(res => {
          if (res.msg == "已完成") {
            this.$message({message: "操作成功~",type: "success"});
            this.GetRAPWaitTasks();
          } else {
            this.$message.error("审批失败,请重试");
          }
        });
      });
    },
    //下载模板
    download_doc(file_path) {
      window.open(file_path);
    },
    //打开显示详情dialog
    async DialogBox(row) {
      this.DialogVisible = true;
      await GetStepTimeLine(this.userInfo.userid, row.InstanceID).then(res => {
        res.TimeLines.forEach(e => {
          if (e.Result == '0') {
            e.Result = "wait";
          } else if (e.Result == 2) {
            e.Result = "finish";
          } else if (e.Result == 3) {
            e.Result = "error";
          } else if (e.Result == 4) {
            e.Result = "finish";
          } else if (e.Result == 5) {
            e.Result = "error";
          }
        });
        this.TimeLines = res.TimeLines;
        this.level = res.NowStep;
      });
      await GetNeedDtail(row.InstanceID).then(res => {
        this.rowInfo = res.Data;
      });
    },
    //打开抄送dialog
    async ccDialogBox(row){
      this.itemInfo = row;
      this.ccDialogVisible = true;
      this.ccProps = {
        lazy: true,
        lazyLoad: (node, resolve) => {
          GetFrameByParentId(node.value).then((res) => {
            if (res.length > 0) {
              var nodes = [];
              res.forEach((element) => {
                var node = {
                  value: element.Id,
                  label: element.ClassName,
                  leaf: false,
                };
                nodes.push(node);
              });
              resolve(nodes);
            } else {
              GetUserByParentId(node.value).then((users) => {
                var nodes = [];
                if (users.DataList.length > 0) {
                  users.DataList.forEach((element) => {
                    var node = {
                      value: element.Id,
                      label: element.TrueName,
                      leaf: true,
                    };
                    nodes.push(node);
                  });
                }
                resolve(nodes);
              });
            }
          });
        },
      }
    },
    //关闭抄送dialog并清除行数据
    ccDialogClose(){
      this.itemInfo = {};
    },
    //选择咨询师
    passDialogClose(){
      this.passDialogVisible=false;
    },
    //上传方案
    passFangAnDialogClose(){
      this.passFangAnDialogVisible=false;
    },
    //选择抄送人
    onCcChange(val){
      // this.$refs.CcCascader.getCheckedNodes()[0].pathLabels 获得node节点下的label值
      this.ccId = val[val.length-1];
    },
    //确认并抄送
    ccBtn(){
      this.ccId = this.ccId[this.ccId.length-1];
      if(this.ccId == ''){
        this.$message('请选择要抄送的对象');
      }else{
        this.pass(this.itemInfo,this.ccId).then(res=>{
          this.ccDialogVisible = false;
        });
      }
    },
    //打开转交dialog
    async transmitDialogBox(row){
      this.itemInfo = row;
      this.taskId = row.ID
      this.transmitDialogVisible = true;
      this.ccProps = {
        lazy: true,
        lazyLoad: (node, resolve) => {
          GetFrameByParentId(node.value).then((res) => {
            if (res.length > 0) {
              var nodes = [];
              res.forEach((element) => {
                var node = {
                  value: element.Id,
                  label: element.ClassName,
                  leaf: false,
                };
                nodes.push(node);
              });
              resolve(nodes);
            } else {
              GetUserByParentId(node.value).then((users) => {
                var nodes = [];
                if (users.DataList.length > 0) {
                  users.DataList.forEach((element) => {
                    var node = {
                      value: element.Id,
                      label: element.TrueName,
                      leaf: true,
                    };
                    nodes.push(node);
                  });
                }
                resolve(nodes);
              });
            }
          });
        },
      }
    },
    //关闭转交dialog并清除行数据
    transmitDialogClose(){
      this.itemInfo = {};
    },
    //关闭拒绝数据
    refuseDialogClose(){
      this.refuseRemark='';
      this.refuseDialogVisible=false;
    },
    //关闭通过数据
    passDialogClose(){
      this.passRemark = '';
      this.passDV = false;
    },
    //选择转交人
    onTransmitChange(val){
      this.ccId = val[val.length-1];
      // 获得node节点下的label值
      var transmitName = this.$refs.TransmitCascader.getCheckedNodes()[0].pathLabels;
      this.transmitName = transmitName[transmitName.length-1];
    },
    //转交并抄送
    transmitBtn(){
      this.ccId = this.ccId[this.ccId.length-1];
      // 获得node节点下的label值
      var transmitName = this.$refs.TransmitCascader.getCheckedNodes()[0].pathLabels;
      this.transmitName = transmitName[transmitName.length-1];
      if(this.reason == ''){
        this.reason = '无'
      }
      if(this.ccId == ''){
        this.$message('请选择要抄送的对象');
      }else{
        RAPHandOverOper(this.userInfo.TrueName,this.transmitName,this.taskId,this.ccId,this.reason).then(res=>{
          if(res.Message == '操作成功'){
            this.$message({message: "操作成功~",type: "success"});
            this.transmitDialogVisible = false;
          }else{
            this.$message('操作失败');
          }
        });
      }
    },
  },
  created() {
    var userinfo = JSON.parse(cryptoDecode(window.sessionStorage.getItem('userinfo')));
    this.userInfo.TrueName = userinfo.TrueName
    this.userInfo.userid = userinfo.UserId; 
    // this.userInfo.userid = "2ada3e15-b153-4dab-93ee-84ba9c2b4848";
    this.GetRAPWaitTasks();
    // this.GetRAPBtn();
  }
};
</script>
<style lang="less" scoped>
.refund_home{
  height: 100px;
  margin-bottom: 12px;
}
.sub {
  font-size: 12px;
  color: #8f8d8d;
}
.el-table {
  margin-top: 15px;
}
.el-pagination {
  margin-top: 15px;
}
.el-drawer {
  padding: 0 15px !important;
}
.drawer_box {
  width: 100%;
}
.el-dropdown {
  transform: translateY(10px);
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.text_right {
  text-align: right;
}
.text_left {
  text-align: left;
}
.item_height {
  height: 40px;
  line-height: 40px;
}

.ccDialogText{
  text-align: right;
  height: 32px;
  line-height: 32px;
  // padding-right: 18px;
}
.ccDialogBtn{
  height: 32px;
  line-height: 32px;
}

.info_table{
  margin-top: 4px;
  width: 100%;
  border: 1px solid #eee;
}
.tableRow,.tableRowBox{
  min-height: 38px;
}
.tableTitle{
  text-align: center;
  height: 38px;
  line-height: 38px;
  background-color: #FAFAFA;
  border-right: 1 solid #eee !important;
}
.tableTd{
  background-color: #FFF;
  text-align: center;
  line-height: 38px;
  border-right: 1 solid #eee !important;
}
.dividerRow{
  border-top: 1px solid #eee;
}
.tableRowBox{
  width: 100%;
  display: flex;
  box-sizing: border-box;
}
.table_left{
  position: relative;
  text-align: center;
  background-color: #FAFAFA;
  width: 25%;
  box-sizing: border-box;
  border-bottom: 1px solid #FFF;
}
.table_left span{
  position: absolute;
  top: 50%;
  left: 50%;
  transform : translateX(-50%) translateY(-50%);
  
}
.table_right{
  width: 75%;
  padding: 8px;
  box-sizing: border-box;
  border-top: 1px solid #FAFAFA;
}
.downloadBtn{
  display: flex;
  justify-content: flex-end;
}
</style>
